import {LitElement, html, css} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {navigator, router} from 'lit-element-router';
import {connect} from 'pwa-helpers';

import style from '../../../../scss/activityListItem.scss';
import listStyle from '../../../../scss/list.scss';
import store from '../../store';

@customElement('arc-activity-list-item')
export class ActivityListItem extends connect(store)(navigator(LitElement)) {
	static styles = [listStyle, style];

	static properties = {
		log: {type: Object},
		currentLanguage: {type: String},
		customClass: {type: String},
		isDropdownOpen: {type: Boolean},
	};

	constructor() {
		super();
		this.isDropdownOpen = false;
		store.subscribe(() => this.requestUpdate());
	}

	connectedCallback() {
		super.connectedCallback();
	}

	render() {
		return html`
			<div class="listItem small">
				<div>
					${this.log.created}
				</div>
				<div class="activityName">
					${this.log.activityName}
				</div>
				<div>
					${this.log.artworkTitle}
				</div>
				<div>
					${this.log.accountName}
				</div>
				<div>
					${this.log.profileName}
				</div>
			</div>
    `;
	}
}
